import { createContext, useState, useCallback } from 'react';

export const CourseContext = createContext();

export function CourseProvider({ children }) {
  const [courses, setCourses] = useState([]);
  const [coursesLoaded, setCoursesLoaded] = useState(false);

  /**
   * Store the list of courses we have permissions for
   */
  const storeCourses = useCallback((courseList) => {
    setCourses(courseList || []);
    setCoursesLoaded(true);
  }, []);

  /**
   * Get a course by ID - ensures we're using a valid course ID
   */
  const getCourseById = useCallback((courseId) => {
    return courses.find(course => course.id === parseInt(courseId));
  }, [courses]);

  /**
   * Check if a course ID is in our list of authorized courses
   */
  const isAuthorizedCourse = useCallback((courseId) => {
    return courses.some(course => course.id === parseInt(courseId));
  }, [courses]);

  const value = {
    courses,
    coursesLoaded,
    storeCourses,
    getCourseById,
    isAuthorizedCourse
  };

  return (
    <CourseContext.Provider value={value}>
      {children}
    </CourseContext.Provider>
  );
}
